"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var genders_1 = require("../../../constants/genders");
/**
 * Helper method that translates a gender character to a readable string
 *
 * @param gender - The gender string to evaluate
 */
function genderString(gender) {
    switch (gender) {
        case genders_1.MALE:
            return 'Masculino';
        case genders_1.FEMALE:
            return 'Femenino';
        default:
            return 'Otro';
    }
}
exports.default = genderString;
//# sourceMappingURL=genderString.js.map